module.exports = __webpack_public_path__ + "static/media/startbild_sw_ohne_flasche.4b428fd4.jpg";